/* eslint-disable */
import { getStageTheme, getStageLabel, getStageNumber, getStageIcon } from "./devCardUtils";

export function getBasedOnData(dev, allDevs, catalogItems) {
  const bod     = dev.based_on_data || dev.data?.based_on_data || {};
  const basedOn = dev.based_on      || dev.data?.based_on      || "";
  if (!basedOn) return null;

  if (basedOn === "Original Item (Catalog)") {
    const item = bod.item_id ? (catalogItems||[]).find(i => i.id === bod.item_id) : null;
    return {
      type: "catalog",
      name: item?.data?.model || item?.model || item?.data?.brand || item?.brand || bod.brand || "Originals Item",
      brand: item?.data?.brand || item?.brand || "",
      ref:   item?.data?.sku  || item?.sku   || bod.sku || "",
      imageUrl: (item?.images||[])[0] || bod.ref_image || null,
      item,
    };
  }
  if (basedOn === "Image / Fty Sample" || basedOn === "Brand Image / Reference") {
    // T-1051 — Image / Fty Sample dispatches on bod.sub_type.
    // Legacy "Brand Image / Reference" kept here for the SQL-deploy-skew window;
    // post sql/dev-based-on-01 run, all such rows are normalized to the new string.
    const subType = bod.sub_type || 'brand';
    if (subType === 'fty') {
      return { type:"fty", name:bod.factory_name||"Fty Sample", brand:"", ref:bod.factory_name||"", imageUrl:bod.ref_image||null };
    }
    return { type:"brand", name:bod.brand_name||"Brand Reference", brand:bod.brand_name||"", ref:bod.ref_code||"", imageUrl:bod.ref_image||null };
  }
  if (basedOn === "Store Model (CL)") {
    return { type:"cl", name:bod.cl_number||"CL Model", brand:"Carolina Lemke", ref:bod.cl_number||"", imageUrl:bod.ref_image||null };
  }
  // Other — T-1051 added bod.images = [{url, name}, ...] multi-image support.
  const otherImgs = Array.isArray(bod.images) ? bod.images : [];
  const otherPrimary = otherImgs[0]?.url || bod.ref_image || null;
  return { type:"other", name:bod.description?.slice(0,40)||basedOn, brand:"", ref:"", imageUrl:otherPrimary };
}

export function getSiblings(dev, allDevs) {
  const bod     = dev.based_on_data || dev.data?.based_on_data || {};
  const basedOn = dev.based_on      || dev.data?.based_on      || "";
  if (!basedOn) return [];
  return (allDevs||[]).filter(d => {
    if (d.id === dev.id) return false;
    const dBod = d.based_on_data || d.data?.based_on_data;
    if (!dBod) return false;
    if (basedOn==="Original Item (Catalog)"    && bod.item_id)   return dBod.item_id   === bod.item_id;
    // T-1051 — Image / Fty Sample sibling matches on ref_image url regardless of
    // sub_type (both brand + fty store ref_image at the same key). Legacy
    // 'Brand Image / Reference' covered by OR-clause for SQL-deploy-skew window.
    if ((basedOn==="Image / Fty Sample" || basedOn==="Brand Image / Reference") && bod.ref_image) return dBod.ref_image === bod.ref_image;
    if (basedOn==="Store Model (CL)"           && bod.cl_number) return dBod.cl_number === bod.cl_number;
    return false;
  });
}

export function getStageForCompare(dev) {
  const theme = getStageTheme(dev);
  return { name:getStageLabel(dev), number:getStageNumber(dev), icon:getStageIcon(dev), sash:theme.sash, light:theme.light, text:theme.text };
}
